'use client';

import { usePopup } from '@/hooks/use-popup';
import { useTranslation } from '@/i18n/client';
import { eventFilterKeys, FilterItem } from '@/types/filters';
import { WithLang } from '@/types/general';

import SelectFilter from '../elements/select/select-filter';
import { filtersColorMap } from './calendar-constants';
import CalendarFilterLabel from './calendar-filter-label';
import { FiltersProps } from './calendar-types';

export default function CalendarFiltersMobile(props: WithLang<FiltersProps>) {
    const { t } = useTranslation(props.lang, 'filters');

    const { openPopup, closePopup, isVisible } = usePopup({ popup: false });

    return (
        <div>
            <button onClick={() => openPopup('popup')} className="my-6 w-full rounded border border-black py-2">
                {t('common_filters', { count: props.filtersSelectedCount })}
            </button>
            <div
                className={`transform-transition fixed inset-0 z-[3] flex flex-col overflow-y-scroll overscroll-contain rounded-t-lg bg-white duration-300 ${
                    isVisible.popup ? 'visible translate-y-0' : 'invisible translate-y-full'
                }`}
            >
                <div className="relative py-6">
                    <p className="text-center">{t('common_filters_zero')}</p>
                    <div onClick={() => closePopup('popup')} className="square-button absolute right-2 top-6">
                        <span className="icon bg-close" />
                    </div>
                </div>

                <div className="mt-10 flex h-full flex-col px-4 pb-4">
                    <div className="flex flex-col gap-4">
                        {eventFilterKeys.map((fKey) => (
                            <SelectFilter
                                selectType={fKey === 'price' || fKey === 'language' ? 'select' : 'input'}
                                lang={props.lang}
                                key={fKey}
                                defaultValue={t(`${fKey}`, { count: props.filtersSelected[fKey].length })}
                                options={props.filtersAvailable[fKey]}
                                onClick={(item: FilterItem) => props.handleAddFilter(item)}
                            />
                        ))}
                    </div>
                    <div className="mt-4 flex max-w-fit flex-wrap gap-3">
                        {eventFilterKeys.map((fKey) => (
                            <CalendarFilterLabel
                                lang={props.lang}
                                key={fKey}
                                className={filtersColorMap[fKey]}
                                options={props.filtersSelected[fKey]}
                                onRemove={props.handleRemoveFilter}
                            />
                        ))}
                    </div>
                    <div className="mt-auto">
                        <button onClick={props.onReset} className="w-full px-3 py-4">
                            {t('reset')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
